var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTickSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.371 0H18.642C23.049 0 26 3.094 26 7.696V18.3183C26 22.906 23.049 26 18.642 26H7.371C2.964 26 0 22.906 0 18.3183V7.696C0 3.094 2.964 0 7.371 0ZM12.2596 16.8872L18.4346 10.7122C18.8766 10.2702 18.8766 9.55515 18.4346 9.10015C17.9926 8.65815 17.2646 8.65815 16.8226 9.10015L11.4536 14.4692L9.17856 12.1942C8.73656 11.7522 8.00856 11.7522 7.56656 12.1942C7.12456 12.6362 7.12456 13.3512 7.56656 13.8062L10.6606 16.8872C10.8816 17.1082 11.1676 17.2122 11.4536 17.2122C11.7526 17.2122 12.0386 17.1082 12.2596 16.8872Z",
    fill: "#29D985"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTickSquare);
export default __webpack_public_path__ + "static/media/icon-Tick-square.83c3c635.svg";
export { ForwardRef as ReactComponent };